import { BigNumber } from '@xylabs/sdk-js'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseBigNumber = (input: any) => {
  const inputString: string = input.toString()
  if (inputString.startsWith('0x')) {
    return new BigNumber(inputString.substring(2), 16)
  }
  return new BigNumber(inputString.toString(), 10)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseBigNumberOptional = (input?: any, defaultValue?: BigNumber | string | number) => {
  if (input) {
    return new BigNumber(input.toString())
  }
  if (defaultValue) {
    return new BigNumber(defaultValue)
  }
}
